import logger from '../log';
import BaseInteraction from './BaseInteraction';
import bindFlowplayerToWebRTC from '../webrtc/bindFlowplayerToWebRTC';
import { SourceType } from '../common/constants';
import ContentItem from '../api/content/ContentItem';
import { BindOptions } from './interfaces';
import { Flowplayer, PlayerNames } from '@kollective-frontend/ksdk-api';
import { Types, checkType, logUnableToSetupMessage } from '../util/checkTypes';

const log = logger.getLogger(__filename);

export default class FlowplayerInteraction extends BaseInteraction<Flowplayer> {
  constructor(player: Flowplayer) {
    super(player);
    checkType(player, Types.FLOW).emitErrorIfNotCorrectType();
  }

  bindInterceptor(
    shouldIntercept: () => boolean,
    getOptions: () => BindOptions
  ): void {
    super.bindInterceptor(shouldIntercept, getOptions);
    // XXX: The following should eventually be moved into the constructor,
    // after confirming that there are no complication based on change of timing.
    const result = checkType(this.player, Types.FLOW);
    if (result.isType) {
      bindFlowplayerToWebRTC(this.player, this.binder);
    } else {
      logUnableToSetupMessage(PlayerNames.FLOW_PLAYER, log, result);
    }
  }

  loader(items: ContentItem[]): ContentItem[] {
    const [firstSrc] = items;
    // https://shaka-player-demo.appspot.com/docs/api/shaka.Player.html load method
    this.setSource(firstSrc.url);
    return [firstSrc];
  }

  setSource(url: string): void {
    this.player.setSrc(url);
  }

  clearSource(): void {
    log.warn(this.generatePlannedErrorMessage('clearSource', 'Flowplayer'));
    // Implementing this should be as simple as uncommenting this and testing it.
    // this.setSource(null);
  }

  videoElement(): HTMLVideoElement {
    // the player is an extended element
    return this.player;
  }

  getAllowedSourceTypes(): SourceType[] {
    return [SourceType.HLS];
  }
}
